import { z } from "zod"

export const ActivityScoresDataSchema = z.object({
  website_promotion_priority: z.number().min(0).max(100),
  industry_trends_sensitivity: z.number().min(0).max(100),
  competitor_matching: z.number().min(0).max(100),
  engagement_vs_conversion_tradeoff: z.number().min(0).max(100),
  platform_specific_adaptation: z.number().min(0).max(100),
  event_relevance_score: z.number().min(0).max(100),
  trend_score: z.number().min(0).max(100),
  competitor_link_rate: z.number().min(0).max(100),
  viral_score: z.number().min(0).max(100),
  average_engagement_rate: z.number().min(0).max(100),
  average_click_through_rate: z.number().min(0).max(100),
  brand_ambassador_activity: z.number().min(0).max(100),
  event_urgency_score: z.number().min(0).max(100),
  platform_score: z.number().min(0).max(100),
});

export type ActivityScoresDataType = z.infer<typeof ActivityScoresDataSchema>

export type ActivityName =
  | "website_promotion_priority"
  | "industry_trends_sensitivity"
  | "competitor_matching"
  | "engagement_vs_conversion_tradeoff"
  | "platform_specific_adaptation"
  | "event_relevance_score"
  | "trend_score"
  | "competitor_link_rate"
  | "viral_score"
  | "average_engagement_rate"
  | "average_click_through_rate"
  | "brand_ambassador_activity"
  | "event_urgency_score"
  | "platform_score";

export type ActivityScore = {
  activity_name: ActivityName;
  activity_score: number;
};
